import gql from 'graphql-tag';

export const SHARED_COMMISSION_FRAGMENT = gql`
  fragment SharedCommissionInfo on SharedCommission {
    id
    beneficiary {
      id
      firstName
      lastName
    }
    amount
  }
`;
